"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$text, _theme$palette2, _theme$palette2$secon;

  return {
    item: {
      alignItems: "center",
      display: "flex",
      "& a": {
        color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$text = _theme$palette.text) === null || _theme$palette$text === void 0 ? void 0 : _theme$palette$text.primary,
        display: "flex",
        gap: theme.spacing(1)
      },
      "& a:hover": {
        color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$secon = _theme$palette2.secondary) === null || _theme$palette2$secon === void 0 ? void 0 : _theme$palette2$secon.main
      }
    },
    icon: {
      alignItems: "center",
      display: "flex",
      margin: theme.spacing(0, 2, 0, 0)
    },
    label: {
      fontWeight: 700
    }
  };
});
var _default = styles;
exports.default = _default;